// servicesList.js

const servicesList = {
  // 1. NATUROPATÍA ALIMENTARIA
  "naturopatia-alimentaria": [
    {
      id: 1,
      title: "Programa de Pérdida de Peso",
      description:
        "El plan ideal para reducir tu grasa corporal de forma saludable, equilibrando macronutrientes y hábitos de vida.",
      imageUrl: "/assets/images/services/service-1.jpg", // Renamed from "service-1jpg" to "service-1.jpg"
      link: "/naturopatia-alimentaria/perdida-peso",
    },
    {
      id: 2,
      title: "Mantenimiento",
      description:
        "Mantén tus resultados a largo plazo con un enfoque flexible y revisiones periódicas para adaptarte a nuevos retos de salud.",
      imageUrl: "/assets/images/services/service-2.jpg",
      link: "/naturopatia-alimentaria/mantenimiento",
    },
    {
      id: 3,
      title: "Soporte Online",
      description:
        "Conéctate con nuestro equipo desde cualquier lugar, recibiendo asesoría integral y personalizada de forma remota.",
      imageUrl: "/assets/images/services/service-6.jpg",
      link: "/naturopatia-alimentaria/soporte-online",
    },
  ],

  // 2. PSICOLOGÍA
  "psicologia": [
    {
      id: 1,
      title: "Sesiones Grupales",
      description:
        "Descubre técnicas efectivas para manejar el estrés, la ansiedad y la depresión, con un acompañamiento psicológico integral.",
      imageUrl: "/assets/images/services/service-psych-1.jpg",
      link: "/psicologia/adultos",
    },
    {
      id: 2,
      title: "Adultos",
      description:
        "Descubre técnicas efectivas para manejar el estrés, la ansiedad y la depresión, con un acompañamiento psicológico integral.",
      imageUrl: "/assets/images/services/service-psych-1.jpg",
      link: "/psicologia/adultos",
    },
    {
      id: 3,
      title: "Soporte Online",
      description:
        "Conéctate con nuestro equipo desde cualquier lugar, recibiendo asesoría integral y personalizada de forma remota.",
      imageUrl: "/assets/images/services/service-6.jpg",
      link: "/psicologia/soporte-online",
    },
    {
      id: 4,
      title: "Adolescentes",
      description:
        "Acompañamos a los jóvenes en su proceso de autodescubrimiento, fortaleciendo su autoestima y gestionando conflictos familiares o escolares.",
      imageUrl: "/assets/images/services/service-psych-2.jpg",
      link: "/psicologia/adolescentes",
    },
    {
      id: 5,
      title: "Deportistas",
      description:
        "Maximiza tu rendimiento mental y tu concentración deportiva con técnicas de psicología enfocadas en la motivación y la superación de obstáculos.",
      imageUrl: "/assets/images/services/service-psych-3.jpg",
      link: "/psicologia/deportistas",
    },
  ],

  // 3. SERVICIOS INTEGRALES
  "otros-servicios": [
    {
      id: 1,
      title: "Opositores",
      description:
        "Te ayudamos a optimizar tu tiempo de estudio, energía y foco mental para superar con éxito tus oposiciones.",
      imageUrl: "/assets/images/services/service-4.jpg",
      link: "/otros-servicios/opositores",
    },
    {
      id: 2,
      title: "Corredores",
      description:
        "Planes especializados para elevar tu resistencia, velocidad y adaptarte a las exigencias de las competencias.",
      imageUrl: "/assets/images/services/service-5.jpg",
      link: "/otros-servicios/corredores",
    },
    {
      id: 3,
      title: "Aumento de la Masa Muscular",
      description:
        "Potencia tu entrenamiento con un plan alimenticio rico en proteínas y ajustado a tus objetivos de ganancia muscular.",
      imageUrl: "/assets/images/services/service-3.jpg",
      link: "/otros-servicios/aumento-masa-muscular",
    },
    {
      id: 4,
      title: "Servicio para Empresas",
      description:
        "Implementamos programas de bienestar corporativo, mejorando la salud, productividad y motivación de tu equipo.",
      imageUrl: "/assets/images/services/service-7.jpg",
      link: "/otros-servicios/servicios-a-empresas",
    },
  ],
};

export default servicesList;
